<template>
  <div class="full-screen" style="z-index: 1; padding-top: 3px;">


    <!-- 下载app -->
    <div id="downloadTip" class="header row fixed-top" v-if="!this.inWebView">
      <span class="btn" href="#" @click="closeDownloadTip"></span>
      <span><img src="../../assets/images/logo.png"></span>

      <div class="flex cc">
        <span class="f14">海量未删减高品质漫画</span>
      </div>

      <p class="cc">
        <a v-show="inAndroidBrowser" class="cc" @click="downloadAndroidApp">下载APP</a>
        <a v-show="inIosBrowser" class="cc" @click="showIosFixDesktopStep=true">添加到桌面</a>
      </p>
    </div>

    <!-- 添加主屏幕 -->
    <div v-show="showIosFixDesktopStep" class="add-icon">
      <div class="dialog-bottom row">
        <div class="dialog-down"></div>
        <span class="cc">请点击</span>
        <span class="cc"><img class="img" src="../../assets/img/icon-20.png"></span>
        <span class="cc">然后点击“添加到主屏幕”</span>
      </div>
      <div class="dialog-mask" @click="showIosFixDesktopStep=false"></div>
    </div>



    <div id="scroll-div-home" class="scroll-list" style="height: calc(100% - 50px);">

      <!-- 轮播 -->
      <div>
        <swiper :ad-list="pageInfo.adList"></swiper>
      </div>

       <!-- 导航 -->
      <div class="hd-nav">
        <ul>
          <li class="i1" @click="toRanking">排行</li>
          <!-- <li class="i4" @click="toAnimeVod">动漫</li>
          <li class="i2" @click="toPurchase">充值</li> -->

          <li class="i6" @click="toCategory">漫画分类</li>
          <li class="i7" @click="toHistory">漫画收藏</li>

          <li v-if="inAndroidBrowser" class="i3" @click="downloadAndroidApp">APP</li>
          <li v-if="inIosBrowser" class="i3" @click="showIosFixDesktopStep=true">APP</li>
          <li class="i5" @click="toBookSearch">搜索</li>
        </ul>
      </div>

      <!-- 每日更新 -->
      <div class="day-update-box">
        <div class="title row">
          <i></i>
          <span class="flex cc">每日更新</span>
          <!-- <a class="ccc" @click="changeCategory(selected.category)">换一批</a> -->
          <a class="cc"  @click="toDayUpdate">更多</a>
        </div>
        <ul class="ul">
          <li  :class="{ active: getCategoryActive === 'all' }"  @click="changeCategory('all',0)">全部</li>
          <li v-for="(item, index) in categoryList" :key="item.id" :class="{ active: getCategoryActive === item.id }"
                @click="changeCategory(item.id,0)">{{ item.name }}</li>
        </ul>
        <div class="day-update-list">
          <ul v-if="todayUpdateBooks && todayUpdateBooks.length > 0" class="booklist">
            <li v-for="(item, index) in todayUpdateBooks" :key="index">
              <a class="cc" @click="toBookDetail(item.bookId)">
                <div class="pic">
<!--                  <img :imgpath="getCoverPath(item.cover)" v-lazy="require('../../assets/images/loading.jpeg')" :alt="item.title"/>-->
                  <img :bookid="item.bookId" :booktitle="item.title" :chapternum="0" :imgpath="item.cover" :zoom="1000" v-lazy="require('../../assets/images/loading.jpeg')" :alt="item.title">
                  <span v-if="item.showPop" :class="['book-pop', item.popClass]">{{item.popText}}</span>
                  <span  :class="['book-tag', {'tag-red': item.publishStatus !== 'finish', 'tag-green': item.publishStatus === 'finish'}]">{{getPublishStatusText(item.publishStatus)}}</span>
                </div>
                <span>{{item.title}}</span>
              </a>
            </li>
          </ul>
        </div>


        <div v-if="isLoading" class="home-loading"></div>
      </div>

      <!-- 频道橱窗 -->
      <div class="main">
        <books-small
          :title="'每日推荐'"
          :books="pageInfo.recommendList"
          :key="key.recommendList"
          :showRefresh="true"
          v-on:show-refresh="showRefresh('e_recommend', currentPage.recommendList);"
          v-on:show-more="toRecommend()">
        </books-small>

        <books-small v-show="threeDList.length>0"
          :title="'真空出境'"
          :books="threeDList"
          :key="key.threeDList"
          :showRefresh="true"
          v-on:show-refresh="showRefresh('three_d', currentPage.threeDList);"
           v-on:show-more="toThreeD">
        </books-small>

        <books-small
          :title="'新书速递'"
          :books="pageInfo.newOnList"
          :key="key.newOnList"
          :showRefresh="true"
          v-on:show-refresh="showRefresh('new_on', currentPage.newOnList);"
          v-on:show-more="toNewOn">
        </books-small>

        <books-small
          :title="'本子写真'"
          :books="pageInfo.bzxzList"
          :key="key.bzxzList"
          :showRefresh="true"
          v-on:show-refresh="showRefresh('bzxz', currentPage.bzxzList);"
          v-on:show-more="toBzxz">
        </books-small>

        <books-full
          :title="'强力重磅'"
          :books="pageInfo.kkbgList"
          :key="key.kkbgList"
          :showRefresh="true"
          v-on:show-refresh="showRefresh('kkbg', currentPage.kkbgList);"
          v-on:show-more="toKkbg">
        </books-full>

        <books-large
          :title="'人气榜单'"
          :books="pageInfo.hotList"
          :key="key.hotList"
          :showRefresh="true"
          v-on:show-refresh="showRefresh('hot', currentPage.hotList);"
          @show-more="toRanked">
        </books-large>

        <books-small v-if="historyList.length > 0" :title="'最近阅读'" :books="historyList"
             @show-more="toRecent"></books-small>
      </div>

    </div>

    <!-- 页脚导航 -->
    <bottom></bottom>

    <!-- 弹窗 是否成功 -->
    <div id="payBackConfirm-modal" v-show="payBackConfirm" class="fixed-confirm" style="display: block;">
      <div class="fixed-c">
        <h3 class="icon-1">是否支付成功？</h3>
        <div class="btnbox">
          <button class="btn" type="button" @click="showPaySuccessAlert">是</button>
          <button class="btn btn2" type="button" @click="showPayFailAlert">否</button>
        </div>
      </div>
    </div>

    <!-- 弹窗 保存账号 -->
    <div id="paySuccess-modal" v-show="paySuccessAlert" class="fixed-confirm" style="display: block;">
      <div class="fixed-c fixed-c-ts">
        <div class="find-success">
          <h3 class="icon-3">
            请记住永久域名
            <strong @click="copyUrl('http://xabmh.com')"  class="font-red-block">xabmh.com</strong>
            <span v-if="inAndroidBrowser" class="tx">
              或<a @click="downloadAndroidApp" class="font-red-block">下载最新APP</a>防止账号丢失!
          </span>
          </h3>
          <div class="find-success">
            <p v-if="!alreadyBoundMobile">请<span style="color:#009ee8; margin: 0 3px;">截图您的账号密码</span>或<span style="color:#009ee8; margin: 0 3px;">绑定手机号</span>！</p>
            <p v-else>您可以使用以下账号或直接使用手机号登录</p>
            <p>账号：<strong ref="act1"></strong></p>
            <p>密码：<strong ref="pwd1"></strong></p>
          </div>
        </div>
        <div class="btnbox">
          <button class="btn" type="button" v-if="!alreadyBoundMobile" @click="toSetPhoneNumber">绑定手机<span class="bi">送40币</span></button>
          <button class="btn btn2" type="button" @click="hidePaySuccessAlert">确定</button>
        </div>
      </div>
    </div>


    <!-- 弹窗 解决办法 -->
    <div id="payFail-modal" v-show="payFailAlert" class="fixed-confirm" style="display: block;">
      <div class="fixed-c fixed-c-ts">
        <h3  class="icon-2">解决办法</h3>
        <div class="find-success">
          <p>1.请截图保存当前账号密码</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;账号：<strong ref="act2"></strong></p>
          <p style="margin-bottom: 20px;">&nbsp;&nbsp;&nbsp;&nbsp;密码：<strong ref="pwd2"></strong></p>
          <p v-show="inWebView || inAndroidBrowser" style="margin-top: 10px;">2.然后<a @click="downloadAndroidApp" style="color: #c32900; margin: 0 3px;"><u>下载最新App</u></a>进行支付</p>
          <p v-show="inIosBrowser">2.然后使用<span color="red">默认浏览器Safiri</span>进行支付</p>
        </div>
        <div class="btnbox">
          <button class="btn" type="button" @click="hidePayFailAlert">确定</button>
        </div>
      </div>
    </div>

  <!-- 弹窗 签到 -->
    <div id="dailySign-modal" v-show="showDailySign"  class="fixed-confirm" style="display: block;">
      <div class="daily-sign">
        <div class="c">
          <div class="t">
            <div v-if="dailySignFinish" class="err-text">{{ dailySignTxt }}</div>
            <strong v-else>VIP可以领双倍金币</strong>
          </div>
          <div class="b">
            <ul>
              <li v-for="(item, index) in userDailySignConfig" :key="index"  :class="currentSignDay > index+1 ? 'end':''" :name="currentSignDay === index+1 && currentSignDay === selectSignDay ? 'active': ''">
                <span>第{{index+1}}天</span>
                <div class="dd">
                  <strong>+{{item}}金币</strong>
                  <strong class="vip">VIP+{{vipDailySignConfig[index]}}金币</strong>
                </div>
              </li>
            </ul>
            <div class="btnbox">
              <button class="btn" v-if="!dailySignFinish" type="button" @click="dailySignClick">签到</button>
              <button class="btn" v-else type="button" @click="showDailySign = false">关闭</button>
            </div>
            <div class="ccc"  @click="showDailySign = false">X</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗 成功 -->
    <div id="dailySignSuccess-modal" v-show="showDailySignSuccess" class="fixed-confirm" style="display: block;">
      <div class="dailySignSuccess">
        <div class="cc">
            <div class="s">+{{ receiveCount }}金币</div>
            <div class="p">VIP签到奖励翻倍</div>
            <div class="btnbox">
              <button class="btn" type="button" @click="showDailySignSuccess = false">确认</button>
            </div>
        </div>
      </div>
    </div>


    <div class="download-pops" v-if="inAndroidBrowser && !inWebView" @click="downloadAndroidApp">
      <div class="tx">下载APP，每日领金币</div>
    </div>
    

    <!-- 弹窗 alert -->
    <alert :show="showAlert" :msg="alertMsg" @hided="showAlert = false"></alert>

    <div class="fixed-qd" style="z-index: 10" @click="showDailySignClick"><span>签到</span></div>

    <div v-if="isMainLoading" class="home-main-loading"></div>


    

  </div>
</template>

<script>
  import Swiper from '@/components/share/swiper'
  import BooksSmall from '@/components/share/books-small'
  import BooksLarge from '@/components/share/books-large'
  import BooksFull from '@/components/share/books-full'
  import Bottom from '@/components/layer1/bottomIndex'
  import Recommend from '@/pages/layer2/books/recommend'
  import homeService from '../../services/homeService'
  import shelfService from "../../services/shelfService";
  import swiperService from "../../services/swiperService";
  import payService from "../../services/payService";
  import userService from "../../services/userService";
  import kkUtil from "../../assets/js/kk-util";
  import cookieUtil from "../../assets/js/cookie-util";
  import commService from "../../services/commService";
  import BooksMiddle from "../../components/share/books-middle";
  import {getReportUrl} from "../../services/urlService";
  import Alert from "../../components/share/alert";
  import getAxios from "../../services/axiosService";
  import listService from "../../services/listService";
  import Loading from "../../components/share/loading";

  export default {
    name: "home",
    data() {
      return {
        payBackConfirm: false,
        paySuccessAlert: false,
        payFailAlert: false,
        userInfo: null,
        componentName: '',
        pageInfo: {
          adList: [],
          recommendList: [],
          newOnList: [],
          kkbgList: [],
          hotList: [],
          newList: [],
          updateList: [],
          bzxzList: [],
        },
        key:{
          recommendList: 100,
          threeDList: 200,
          newOnList: 300,
          kkbgList: 400,
          hotList: 500,
          bzxzList: 600,
        },
        currentPage:{
          recommendList: 1,
          threeDList: 1,
          newOnList: 1,
          kkbgList: 1,
          hotList: 1,
          bzxzList: 1,
        },
        threeDList: [],
        historyList: [],
        downloadTitle: '下载App',
        showAddTip: false,
        commInfo: {},
        showAlert: false,
        alertMsg: '',
        showIosFixDesktopStep: false,
        inWebView: false,
        inAndroidBrowser: false,
        inIosBrowser: false,

        categoryList: [],
        selected: {
          category: 'all',
          pageSize: 9,
        },
        todayUpdateBooks:[],
        todayUpdateCurrentPage: 0,
        isLoading: false,
        isMainLoading: false,
        isNoMoreData: false,
        totalItem: 0,

        showDailySign: false,
        showDailySignSuccess: false,
        vipDailySignConfig: [], //vip签到
        userDailySignConfig: [], //普通用户签到
        currentSignDay: 0, //【登录才有】(当前该签第几天)，
        selectSignDay: 0,
        alreadyBoundMobile: false, //【登录才有】(是否已经绑定手机号)
        receiveCount:0,
        dailySignFinish:false,
        dailySignTxt:'',
      }
    },
    computed: {
      getCategoryActive() {
        return this.selected.category
      }

    },
    methods: {
      toCategory() {
        this.$router.push('/category')
      },
      toHistory() {
        this.$router.push('/shelf')
      },
      toDayUpdate(){
        this.$router.push('/home/day')
      },
      toPurchase() {
        this.$router.push('/purchase')
      },
      toRanking() {
        this.$router.push('/home/day-ranked')
      },
      toAnimeVod() {
        this.$router.push('/vod/category?cid=8')
      },
      toSetPhoneNumber(){
        this.$router.push('/user/bind')
      },
      showDailySignClick(){
        if (!this.userInfo) {
          this.register();
        }else{
          this.showDailySign = true
        }

      },
      dailySignClick(){
        this.isMainLoading = true
        let axios = getAxios();
        axios.post('/api/user/daily_sign', {}, {
        })
        .then(res => {
          if(res.data.result){
            console.log(res.data.data.receiveCount)
            this.receiveCount = res.data.data.receiveCount
            this.currentSignDay += 1
            this.showDailySign = false
            this.showDailySignSuccess = true
          }else{
            this.dailySignFinish = true
            this.dailySignTxt = res.data.msg
          }
          this.isMainLoading = false
        })
      },
      register() {
        this.isMainLoading = true
        userService.register()
          .then(res => {
            if (res.result) {
              this.userInfo = res.data;
              this.showDailySign = true
              // this.$refs.act1.textContent = this.userInfo.account;
              // this.$refs.pwd1.textContent = this.userInfo.password;
              // this.$refs.act2.textContent = this.userInfo.account;
              // this.$refs.pwd2.textContent = this.userInfo.password;
              // this.paySuccessAlert = true
              this.currentSignDay = 1
              this.selectSignDay = 1
            }
            this.isMainLoading = false
          })
      },
      showRefresh(type, page){
        this.isMainLoading = true
        let currentPage = page >= 3 ? 1 : page + 1
        listService.getRefreshList(type, currentPage)
          .then(res => {
            if (res.code === 200) {
               switch (type) {
                case 'e_recommend':
                  this.pageInfo.recommendList = res.data.bookList
                  this.currentPage.recommendList = currentPage
                  this.key.recommendList += 1
                  break;
                case 'hot':
                  this.pageInfo.hotList = res.data.bookList
                  this.currentPage.hotList = currentPage
                  this.key.hotList += 1
                  break;
                case 'kkbg':
                  this.pageInfo.kkbgList = res.data.bookList
                  this.currentPage.kkbgList = currentPage
                  this.key.kkbgList += 1
                  break;
                case 'three_d':
                  this.threeDList = res.data.bookList
                  this.currentPage.threeDList = currentPage
                  this.key.threeDList += 1
                  break;
                case 'new_on':
                  this.pageInfo.newOnList = res.data.bookList
                  this.currentPage.newOnList = currentPage
                  this.key.newOnList += 1
                  break;
                case 'bzxz':
                  this.pageInfo.bzxzList = res.data.bookList
                  this.currentPage.bzxzList = currentPage
                  this.key.bzxzList += 1
                  break;
               }

              this.isMainLoading = false
            }else{
              this.isMainLoading = false
            }
          })
      },

      getCategory() {
        listService.getCategory()
          .then(res => {
            this.categoryList = res.data.categoryList
          })
      },
      changeCategory(id,page) {
        this.selected.category = id;
        if(page === 0){
          this.todayUpdateCurrentPage = 0;
        }
        this.getCategoryBooks(this.selected.category);
      },
      getCategoryBooks(category) {
        this.todayUpdateCurrentPage += 1;
        if(this.todayUpdateCurrentPage > 3){
          this.todayUpdateCurrentPage = 1
        }
        this.isLoading = true;
        this.isNoMoreData = false;
        this.todayUpdateBooks = [];
        let _category = category
        if (category === 'all') {
          _category = ''
        }
        listService.getCategoryBooks(_category, this.todayUpdateCurrentPage, this.selected.pageSize)
          .then(res => {
            this.isLoading = false;
            if (res.result) {
              if (res.data.totalPage === 0) {
                this.todayUpdateBooks = [];
              } else {
                //vipDailySignConfigtodayUpdateBooks = res.data.bookList;
                this.todayUpdateBooks = res.data.bookList;
              }
              this.totalItem = res.data.totalItem;
              this.vipDailySignConfig = res.data.vipDailySignConfig.split(',')
              this.userDailySignConfig = res.data.userDailySignConfig.split(',')
              this.currentSignDay = res.data.currentSignDay
              this.selectSignDay = res.data.selectSignDay
              this.alreadyBoundMobile = res.data.alreadyBoundMobile
            }
          })
      },
      toBookDetail(id) {
        this.$router.isBack = false;
        this.$router.push(`/book/${id}`)
      },
      getCoverPath(route) {
        return `${route}_180_0.img`;
      },
      getPublishStatusText(code) {
        if (code === 'finish') {
          return '完结'
        } else {
          return '连载'
        }
      },

      getIndexPage() {
        homeService.getIndexPage()
          .then(res => {
            let data = res.data;
            data.recommendList = data.recommendList.map(item => {
              return {
                ...item,
                showPop: true,
                popClass: {},
                popText: '推荐'
              }
            });
            data.kkbgList = data.kkbgList.map(item => {
              return {
                ...item,
                showPop: true,
                popClass: {},
                popText: '重磅'
              }
            });
            data.hotList = data.hotList.map((item, index) => {
              let i = {
                ...item,
                showPop: true,
                popText: `NO.${index + 1}`
              };
              i.popClass = {};
              i.popClass[`pop-${index}`] = true;
              return i;
            });
            this.pageInfo = data;
            swiperService.setAdList(this.pageInfo.adList);
          });
      },
      loadHistory() {
        this.historyList = shelfService.getHistory().map(item => item.bookInfo).splice(0, 3);
      },
      getThreeDList() {
        homeService.getThreeDList()
          .then(res => {
            let data = res.data;
            data = data.map(item => {
              return {
                ...item,
                showPop: true,
                popClass: {},
                popText: '真空出境'
              }
            });
            this.threeDList = data;
          });
      },
      toUpdate() {
        this.$router.isBack = false;
        this.$router.push('/home/new');
      },
      toRecommend() {
        this.$router.isBack = false;
        this.$router.push('/home/recommend');
      },
      toThreeD() {
        this.$router.isBack = false;
        this.$router.push('/home/three-d');
      },
      toKkbg() {
        this.$router.isBack = false;
        this.$router.push('/home/kkbg');
      },
      toRanked() {
        this.$router.isBack = false;
        this.$router.push('/home/ranked');
      },
      toLatest() {
        this.$router.isBack = false;
        this.$router.push('/home/latest');
      },
      toRecent() {
        this.$router.isBack = false;
        this.$router.push({path: '/shelf', query: {active: 'history'}})
      },
      toNewOn() {
        this.$router.isBack = false;
        this.$router.push({path: '/home/new-on'});
      },
      toBzxz() {
        this.$router.isBack = false;
        this.$router.push({path: '/home/bzxz'});
      },
      toBookSearch() {
        this.$router.isBack = true;
        this.$router.push({path: '/search'});
      },
      // showDownloadTip() {
      //   this.inBrowser = !kkUtil.isInWebView();
      //   // let kkSdt = cookieUtil.getCookie("_kksdt_");
      //   // this.showDownTip = kkSdt == "0" ? false : true;
      //   this.clientType = kkUtil.getClientType();
      //   if (navigator.standalone) {
      //     this.showDownTip = false;
      //   } else {
      //     if (this.inBrowser && this.showDownTip) {
      //       if (this.clientType == "ios") {
      //         this.downloadTitle = "添加桌面";
      //         let dBtn = document.getElementById("downloadBtn");
      //         dBtn.removeAttribute("href");
      //         dBtn.onclick = function () {
      //           let container = document.getElementById("addScreenContainer");
      //           container.style.display = 'block';
      //         }
      //       } else if (this.clientType == "android") {
      //         this.downloadTitle = "下载App";
      //       }
      //     } else {
      //       this.showDownTip = false;
      //     }
      //   }
      // },
      downloadAndroidApp() {
        window.location.href = commService.getLocalInitData().appDownloadUrl;
      },
      closeDownloadTip() {
        let downloadTip = document.getElementById("downloadTip");
        downloadTip.style.display = "none";
        cookieUtil.setCookie("_kksdt_", "0", 0);
      },
      // hideAddContainer() {
      //   let container = document.getElementById("addScreenContainer");
      //   container.style.display = 'none';
      // },
      showPaySuccessAlert() {
        this.payBackConfirm = false;
        this.paySuccessAlert = true;
      },
      hidePaySuccessAlert() {
        this.paySuccessAlert = false;
      },
      showPayFailAlert() {
        this.payBackConfirm = false;
        this.payFailAlert = true;
      },
      hidePayFailAlert() {
        this.payFailAlert = false;
      },
      copyUrl(url){
        (function(){
          document.oncopy = function(e){
            e.clipboardData.setData('text',url)
            e.preventDefault();
            document.oncopy = null;
          }
        })(url);
        document.execCommand('Copy');
        this.alertMsg = '复制成功';
        this.showAlert = true;
      }
    },
    components: {
      BooksMiddle,
      swiper: Swiper,
      'books-small': BooksSmall,
      'books-large': BooksLarge,
      'books-full': BooksFull,
      recommend: Recommend,
      bottom: Bottom,
      alert: Alert,
    },
    mounted() {
      let $this = this;
      this.userInfo = userService.getLocalUserInfo();
      this.commInfo = commService.getLocalInitData();

      this.getCategory();
      this.changeCategory('all', 0);
      this.inWebView = kkUtil.isInWebView();
      this.inAndroidBrowser = kkUtil.isInAndroidBrowser();
      this.inIosBrowser = kkUtil.isInIosBrowser();

      this.componentName = this.$route.name;
      if (this.$store.state.pageState[this.componentName] && this.$router.isBack) {
        Object.assign(this.$data, this.$store.state.pageState[this.$route.name].data);
        setTimeout(() => {
          let scrollDiv = document.getElementById('scroll-div-home');
          scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top;
        }, 5);
      } else {
        this.getIndexPage();
        this.loadHistory();

        //展示真人
        const date = new Date();
        let loadThreeD = false;
        if (date.getHours() >= 21 || date.getHours() < 7) {
          loadThreeD = true;
        } else if (this.userInfo !== null && this.userInfo.recharged !==null && this.userInfo.recharged) {
          loadThreeD = true;
        }
        if (loadThreeD) {
          this.getThreeDList();
        }
      }
      this.$router.isBack = true;



      // this.showDownloadTip();
      // if (this.clientType == "android" && this.inBrowser) {
      //   setTimeout(function () {
      //     document.getElementById("downloadBtn").href = $this.commInfo.appDownloadUrl
      //   }, 1000);
      // }
    },

    watch: {
      commInfo: function () {
        this.$nextTick(function () {
          //支付返回后的弹框逻辑
          if (this.userInfo != null && payService.needAlertPayWarning()) {
            this.payBackConfirm = true;
            this.$refs.act1.textContent = this.userInfo.account;
            this.$refs.pwd1.textContent = this.userInfo.password;
            this.$refs.act2.textContent = this.userInfo.account;
            this.$refs.pwd2.textContent = this.userInfo.password;
          }
          //投诉
          if (this.userInfo == null) {
            this.$refs.homeReportUrl.href = getReportUrl(null);
          } else {
            this.$refs.homeReportUrl.href = getReportUrl(this.userInfo.account);
          }
        });
      }
    },
    beforeDestroy() {
      let scrollDiv = document.getElementById('scroll-div-home');
      let state = {};
      state[this.componentName] = {data: this.$data, top: scrollDiv.scrollTop}
      this.$store.commit('saveState', state);
    }
  }
</script>

<style scoped>
  .home-loading{position: absolute; background: url(../../assets/images/loading4.gif) center center no-repeat; background-size: 40px; top: 70px; left: 0; right: 0; bottom: 0; z-index: 500; opacity: .8;}
</style>



// WEBPACK FOOTER //
// src/pages/layer1/home.vue